import React from 'react';

const SearchInput = ({ value, onChange, placeholder, style, inputStyle, className = 'form-input', name }) => (
  <div style={{ position: 'relative', width: '100%', display: 'flex', ...style }}>
    <input
      type="text"
      name={name}
      className={className}
      placeholder={placeholder}
      value={value}
      onChange={e => onChange(e.target.value)}
      style={{ width: '100%', ...inputStyle, ...(value ? { paddingRight: '30px' } : null) }}
    />
    {value && (
      <button
        type="button"
        onClick={() => onChange('')}
        aria-label="Clear search"
        style={{
          position: 'absolute', right: '6px', top: '50%', transform: 'translateY(-50%)',
          background: 'none', border: 'none', cursor: 'pointer', padding: '4px',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: 'var(--color-text-secondary)', lineHeight: 0,
        }}
      >
        <svg width="13" height="13" viewBox="0 0 14 14" fill="none">
          <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
      </button>
    )}
  </div>
);

export default SearchInput;
